export var textColor = function (text, attrs) {
    return "{color:" + attrs.color + "}" + text + "{color}";
};
//# sourceMappingURL=color.js.map